import { getTableConfigs } from './schemaCache';

export default {
  methods: {
    async generateFiltersForSearch() {
      /*
      TODO: Move this to the docs later? Or keep in code base?

      This method will generate the filters for the search dropdown.
      Depending on the type (derived from the schema_tables) we show different operators.

      The "Label" is the column name as shown on the HOT table, derived from the hotConfig endpoint (Example: Number of Seats)

      Whereas the "ID" is the actual column name (Example: number_of_seats) derived from schema_tables - We need the actual column name for the search query to work correctly.

      Finally, if the type is of "json" we extract the path from the hotConfig endpoint in order to correctly search on nested
      JSON that the Postgres Views grab from other tables.

      For example in the Candidates View, the path to the District ID in the hotConfig schema is:
      "path": [
          "data.race.office.district.id"
      ]

      We parse this into the syntax for querying the JSON in that View for that Column: race->'office'->'district'->>'id'
      */

      let searchFilters = [];

      // Get the fields from the hotConfig:
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/schema/hotConfig?table_name=${this.table}`;

      const [hotConfigResponse, tableConfigs] = await Promise.all([
        fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "GET",
          headers: headers,
          credentials: 'include'
        }),
        getTableConfigs([`${this.table}_view`])
      ]);

      if ( hotConfigResponse.status == 403 ) {
        let response = await hotConfigResponse.json();
        alert(response.message);
        window.location.href = '/login';
      } else {
        let colConfigInfo = await hotConfigResponse.json();
        const fieldInfo = tableConfigs[`${this.table}_view`];
      
        // Loop through the hotConfig information, for each field we will look at the schema_tables as well.
        // This allows us to match them up to get the types
        if (fieldInfo) {
          colConfigInfo.message[0].json_build_object.fields.forEach(configField => {
            fieldInfo.fields.forEach(field => {
              // If the path from the config matches the actual field name,
              // we know it is not nested JSON, and can immediately build the search object:
              if (configField.path[0].split("data.")[1] === field.field_name) {
                // Build the filter objects for each column that exists in the view:
                let filterObject = {}; // Create Empty Object
                filterObject["id"] = field.field_name; // Add id
                filterObject["label"] = configField.column_name; // Add label

                if (field.type.includes("USER-DEFINED")) {
                  // If enum (What if enum is a number.....?)
                  filterObject["type"] = "select";
                  filterObject["operators"] = ["equal", "not_equal", "is_null", "is_not_null"];
                  filterObject["choices"] = [];
                  JSON.parse(field.type.split("USER-DEFINED")[1]).forEach(val => {
                    filterObject["choices"].push({
                      label: val,
                      value: val
                    });
                  });
                } else if (field.type === "character varying" || field.type === "text") {
                  filterObject["type"] = "text";
                  filterObject["operators"] = ["contains", "does_not_contain", "equal", "not_equal", "in", "not_in", "is_null", "is_not_null", "greater", "less"];
                } else if (field.type === "integer" || field.type === "bigint") {
                  filterObject["type"] = "text";
                  filterObject["operators"] = [
                    "equal",
                    "greater",
                    "less",
                    "not_equal",
                    "contains",
                    "does_not_contain",
                    "in_num",
                    "not_in_num",
                    "is_null",
                    "is_not_null"
                  ];
                } else if (field.type === "boolean") {
                  filterObject["type"] = "select";
                  filterObject["operators"] = ["equal", "not_equal"];
                  filterObject["choices"] = [{ label: true, value: true }, { label: false, value: false }];
                } else if (field.type === "ARRAY") {
                  filterObject["type"] = "text";
                  filterObject["operators"] = ["array_contains", "array_does_not_contain", "is_empty", "is_not_empty"];
                } else if (field.type === 'numeric') {
                  filterObject["type"] = "text";
                  filterObject["operators"] = ["equal","less","greater"];
                } else {
                  // TODO: Other types, if they exist.
                }

                searchFilters.push(filterObject);

                /*
                  Next we deal with types that are JSON (Views grab this data from other tables)
                  If the split path from the hotConfig matches a field_name from the schema_tables, we create a searchable dropdown option.
                */
              } else if (configField.path.length === 1 && configField.path[0].split("data.")[1].split(".")[0] === field.field_name) {
                // Example to search on nested JSON... WHERE race->'office'->'district'->>'id' = '5';
                // Create that syntax:

                let tableColumnName = configField.path[0].split("data.")[1].split(".")[0];
                let path = configField.col_to_render ? configField.col_to_render : configField.path[0].split("data.")[1].split(/\.(.+)/)[1];

                if (configField.col_to_render) {
                  tableColumnName = path.split(".")[0];
                  path = path.replace(`${tableColumnName}.`, "");
                }
                let nestedJsonSyntax = tableColumnName + "->" + "'" + path.split(".").join("'->'") + "'";
                nestedJsonSyntax = nestedJsonSyntax.replace(/->([^->]*)$/, "->>" + "$1");

                let filterObject = {}; // Create Empty Object
                filterObject["id"] = `${this.table}_view.${nestedJsonSyntax}`; // Add id
                filterObject["label"] = configField.column_name; // Add label
                filterObject["type"] = "text";

                filterObject["operators"] = ["contains", "equal", "in", "not_equal", "does_not_contain", "is_null", "is_not_null"];
                if ( configField.column_name.includes(' ID')  ) {
                  // ID fields can also be searched in other ways
                  filterObject["operators"] = ["in_num", "not_in_num", "equal", "not_equal", "contains", "does_not_contain", "is_null", "is_not_null" ];
                }
                searchFilters.push(filterObject);
              }
            });
          })
        }

        return searchFilters;
      }
    }
  }
};
